export const imageCardList = [
  {
    id: 1,
    imageUrl: "/assets/images/hot_list/iphone.png",
    title: "iPhone 12 Pro Max",
  },
  {
    id: 2,
    imageUrl: "/assets/images/hot_list/monitor.png",
    title: "Monitor",
  },
  {
    id: 3,
    imageUrl: "/assets/images/hot_list/realme.png",
    title: "Realme 8 Pro",
  },
  {
    id: 4,
    imageUrl: "/assets/images/hot_list/xiaomi.png",
    title: "Xiaomi Mi 11",
  },
];

export const hotListBottom = [
  {
    id: 1,
    imageUrl: "/assets/images/hot_list/iphone_bottom.png",
    title: "iPhone 12 Pro Max",
  },
  {
    id: 3,
    imageUrl: "/assets/images/hot_list/realme_bottom.png",
    title: "Realme 8 Pro",
  },
  {
    id: 4,
    imageUrl: "/assets/images/hot_list/xiaomi_bottom.png",
    title: "Xiaomi Mi 11",
  },
];
